import styled from "styled-components";

export const ErrorHelper = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({theme}) => theme.colors.danger.danger};
  padding: 2px;
`;
